import { render, staticRenderFns } from "./button.vue?vue&type=template&id=4099334a&scoped=true&"
import script from "./button.ts?vue&type=script&lang=ts&"
export * from "./button.ts?vue&type=script&lang=ts&"
import style0 from "./button.scss?vue&type=style&index=0&id=4099334a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4099334a",
  null
  
)

export default component.exports